module.exports = __webpack_public_path__ + "media/packs/images/cost/customs-52210317f0ce708347f8e16908fb9ae5.svg";